import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './SidebarEspacios.css';

const SidebarEspacios = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = React.useState(false);

  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal
    ? `http://${window.location.hostname}:3010`
    : `${window.location.protocol}//${window.location.hostname}`;

  const logout = async () => {
    try {
      await fetch(`${apiBase}/api/espacios/logout`, { method: 'POST', credentials: 'include' });
    } catch (e) { /* continuar aunque falle la red */ }
    localStorage.removeItem('user_espacios');
    navigate('/espacios/login');
  };

  const menuItems = [
    { path: '/espacios/home', icon: 'fa-chart-pie', label: 'Panel Control' },
    { path: '/espacios/areas', icon: 'fa-building', label: 'Áreas y Recintos' },
    { path: '/espacios/reservas', icon: 'fa-calendar-check', label: 'Reservas' },
  ];

  return (
    <aside className={`sidebar-esp ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-esp-header">
        <div className="sidebar-esp-logo">
          <i className="fa-solid fa-map-location-dot"></i>
          {!isCollapsed && <span>Espacios</span>}
        </div>
        <button className="collapse-btn" onClick={() => setIsCollapsed(!isCollapsed)}>
          <i className={`fa-solid ${isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'}`}></i>
        </button>
      </div>

      <nav className="sidebar-esp-nav">
        {menuItems.map(item => (
          <div 
            key={item.path}
            className={`nav-item-esp ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <i className={`fa-solid ${item.icon}`}></i>
            {!isCollapsed && <span>{item.label}</span>}
            {location.pathname === item.path && <div className="active-indicator"></div>}
          </div>
        ))}
      </nav>

      <div className="sidebar-esp-footer">
        <div className="nav-item-esp logout" onClick={logout}>
          <i className="fa-solid fa-right-from-bracket"></i>
          {!isCollapsed && <span>Cerrar Sesión</span>}
        </div>
        
      </div>
    </aside>
  );
};

export default SidebarEspacios;
